import { render } from "./ConfirmationBox.vue?vue&type=template&id=15e13df0&scoped=true"
import script from "./ConfirmationBox.vue?vue&type=script&lang=js"
export * from "./ConfirmationBox.vue?vue&type=script&lang=js"

import "./ConfirmationBox.vue?vue&type=style&index=0&id=15e13df0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e13df0"]])

export default __exports__